<template>
  <div class="loader-container">
    <span class="loading-bubbles">
      <span class="bubble-item"></span>
      <span class="bubble-item"></span>
      <span class="bubble-item"></span>
      <span class="bubble-item"></span>
      <span class="bubble-item"></span>
      <span class="bubble-item"></span>
      <span class="bubble-item"></span>
      <span class="bubble-item"></span>
    </span>
    <span v-if="showText"> {{ $t('labels.loading') }} </span>
  </div>
</template>

<script>
export default {
  name: 'SpinnerLoader',
  data() {
    return {};
  },
  props: {
    showText: true,
  },
};
</script>

<style scoped lang="scss">
.loader-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1em 0;
  color: #a0a0a0;
}

.loading-bubbles {
  $size: 1px;
  $radius: 12px;
  $shallow: 3px;
  $c-basic: #a0a0a0;

  position: relative;
  margin-right: 10px !important;
  .bubble-item {
    $delay: 0.093s;

    background: $c-basic;
    animation: loading-bubbles linear 0.75s infinite;
    position: absolute;
    top: 50%;
    left: 50%;
    display: inline-block;
    border-radius: 50%;
    &:first-child {
      margin-top: -$size/2 + -$radius;
      margin-left: -$size/2;
    }
    &:nth-child(2) {
      animation-delay: $delay;
      margin-top: -$size/2 + -$radius * 0.73;
      margin-left: -$size/2 + $radius * 0.73;
    }
    &:nth-child(3) {
      animation-delay: $delay * 2;
      margin-top: -$size/2;
      margin-left: -$size/2 + $radius;
    }
    &:nth-child(4) {
      animation-delay: $delay * 3;
      margin-top: -$size/2 + $radius * 0.73;
      margin-left: -$size/2 + $radius * 0.73;
    }
    &:nth-child(5) {
      animation-delay: $delay * 4;
      margin-top: -$size/2 + $radius;
      margin-left: -$size/2;
    }
    &:nth-child(6) {
      animation-delay: $delay * 5;
      margin-top: -$size/2 + $radius * 0.73;
      margin-left: -$size/2 + -$radius * 0.73;
    }
    &:nth-child(7) {
      animation-delay: $delay * 6;
      margin-top: -$size/2;
      margin-left: -$size/2 + -$radius;
    }
    &:last-child {
      animation-delay: $delay * 7;
      margin-top: -$size/2 + -$radius * 0.73;
      margin-left: -$size/2 + -$radius * 0.73;
    }
  }
  @keyframes loading-bubbles {
    0% {
      width: $size;
      height: $size;
      box-shadow: 0 0 0 $shallow $c-basic;
    }
    90% {
      width: $size;
      height: $size;
      box-shadow: 0 0 0 0 $c-basic;
    }
    100% {
      width: $size;
      height: $size;
      box-shadow: 0 0 0 $shallow $c-basic;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/SpinnerLoader.vue